// extracted by mini-css-extract-plugin
export default {"container":"yZ-z","list":"zZ-z"};